import gql from "graphql-tag";

export default gql`
  query GetRegisteredAccounts($search: String! = "", $limit: Int! = 50) {
    getRegisteredAccounts(search: $search, limit: $limit) {
      accounts {
        tenantId
        objectId
        displayName
        email
        lastSignedInAt
      }
      hasMore
    }
  }
`;